var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDottedline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_4153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1714 39.3545L15.1839 39.3544M15.1371 31.4967L15.1496 31.4966M15.1028 23.6389L15.1153 23.6389M15.0686 15.7811L15.0811 15.7811M15.0343 7.92333L15.0468 7.92328",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_4153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.1472,
    height: 30,
    fill: "white",
    transform: "translate(0.205688 47.2778) rotate(-90.2499)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedline);
export default __webpack_public_path__ + "static/media/dottedline.b5705ea8d68fb51d01a2d6be5db1b1b4.svg";
export { ForwardRef as ReactComponent };